import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import Frame from '../components/Frame.tsx';
import CoffeeChart from '../components/CoffeeChart';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "coffee-chart"
    }}>{`Coffee Chart`}</h1>
    <p>{`See the component `}<a parentName="p" {...{
        "href": "https://github.com/kristw/encodable/tree/master/packages/docs/src/components/CoffeeChart"
      }}>{`source code`}</a>{`.
or play with the component API by editing the code below.`}</p>

    <Playground __position={0} __code={'<Frame width={360} height={270} background=\"#FFF4F1\">\n  <CoffeeChart\n    width={360}\n    height={270}\n    encoding={{\n      label: { field: \'day\' },\n      drinkLevel: { field: \'numCoffee\', type: \'quantitative\' },\n      drinkColor: {\n        field: \'productivity\',\n        type: \'nominal\',\n        scale: {\n          domain: [1, 2, 3, 4],\n          range: [\'#EAC8C1\', \'#DFAB6D\', \'#B26C4D\', \'#623D2B\'],\n        },\n      },\n      useToGoCup: { field: \'goToOffice\', type: \'nominal\' },\n    }}\n    data={[\n      { day: \'MON\', numCoffee: 2, productivity: 4, goToOffice: true },\n      { day: \'TUE\', numCoffee: 3, productivity: 4, goToOffice: true },\n      { day: \'WED\', numCoffee: 2, productivity: 4, goToOffice: false },\n      { day: \'THU\', numCoffee: 4, productivity: 3, goToOffice: true },\n      { day: \'FRI\', numCoffee: 3, productivity: 2, goToOffice: true },\n      { day: \'SAT\', numCoffee: 1, productivity: 1, goToOffice: false },\n      { day: \'SUN\', numCoffee: 1, productivity: 1, goToOffice: false },\n    ]}\n  />\n</Frame>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Frame,
      CoffeeChart,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Frame width={360} height={270} background="#FFF4F1" mdxType="Frame">
    <CoffeeChart width={360} height={270} encoding={{
          label: {
            field: "day"
          },
          drinkLevel: {
            field: "numCoffee",
            type: "quantitative"
          },
          drinkColor: {
            field: "productivity",
            type: "nominal",
            scale: {
              domain: [1, 2, 3, 4],
              range: ["#EAC8C1", "#DFAB6D", "#B26C4D", "#623D2B"]
            }
          },
          useToGoCup: {
            field: "goToOffice",
            type: "nominal"
          }
        }} data={[{
          day: "MON",
          numCoffee: 2,
          productivity: 4,
          goToOffice: true
        }, {
          day: "TUE",
          numCoffee: 3,
          productivity: 4,
          goToOffice: true
        }, {
          day: "WED",
          numCoffee: 2,
          productivity: 4,
          goToOffice: false
        }, {
          day: "THU",
          numCoffee: 4,
          productivity: 3,
          goToOffice: true
        }, {
          day: "FRI",
          numCoffee: 3,
          productivity: 2,
          goToOffice: true
        }, {
          day: "SAT",
          numCoffee: 1,
          productivity: 1,
          goToOffice: false
        }, {
          day: "SUN",
          numCoffee: 1,
          productivity: 1,
          goToOffice: false
        }]} mdxType="CoffeeChart" />
  </Frame>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      